import React from "react";

const DisclaimersCsvUpload = (props) => (
    <div>
        <h1>Disclaimers CSV Upload</h1>
        <form method="POST"
              action={"/disclosure/api/disclaimers/upload-disclaimers-csv"}
              encType="multipart/form-data">
            <input type="file" name="csv"/>
            <input type="submit" value="Upload"/>
        </form>

        <h1>Interests CSV Upload</h1>
        <form method="POST"
              action={"/disclosure/api/disclaimers/upload-interests-csv"}
              encType="multipart/form-data">
          <input type="file" name="csv"/>
          <input type="submit" value="Upload"/>
        </form>
    </div>
);
DisclaimersCsvUpload.displayName = "DisclaimersCsvUpload";

export default DisclaimersCsvUpload;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/DisclaimersCsvUpload.js
 **/